import React from "react";
import OfficeTwo from "../../assets/images/about-us/office-1.webp";
import { Link } from "react-router-dom";
import ResetLocation from "../../helpers/ResetLocation";

const AboutCollaboration = () => {
  return (
    <article className="about__collaboration">
      <img src={OfficeTwo} alt="" aria-hidden="true" />
      <section className="about__collaboration__content">
        <h2 className="sub-title">Zusammenarbeit</h2>
        <h3>Werden Sie unser Partner</h3>
        <p>
          Sie suchen einen zuverlässigen Catering-Partner für Firmenevents, Geschäftstreffen oder Mittagessen am Arbeitsplatz? Wir bieten hochwertige, geschmackvolle Mahlzeiten, die individuell auf die Bedürfnisse von Unternehmen in unserer Region zugeschnitten sind.
          Unser vielfältiges Menü reicht von handgemachten Pizzen und frischen Salaten bis hin zu Gourmet-Sandwiches und Pasta – für ein rundum zufriedenstellendes Erlebnis für jeden Gast.  
          <br /><br />
        </p>
        <Link to="/contact" onClick={ResetLocation} className="active-button-style">Rückruf anfordern</Link>
      </section>
    </article>
  );
}

export default AboutCollaboration;
